import { resolveObj } from "features/Model/_ducks/selectors";
import { createSelector } from "reselect";

export const formSelector = (state) => state;

const modelForm = createSelector([formSelector], ({ model = {} }) => model);

export const selectForm = createSelector([formSelector], ({ newForm }) => newForm);

export const modelFormSelector = (state) => (path) => {
    const { values = {} } = modelForm(state);
    return !path ? "" : resolveObj(path, values);
};

export const modelFormSyncErrorsSelector = (state) => (path) => {
    const { syncErrors = {} } = modelForm(state);
    return !path ? "" : resolveObj(path, syncErrors);
};

export const selectFormErrors = createSelector([formSelector], ({ newForm: { formErrors = [] } = {} }) => formErrors);
